import React from "react";
import s from "./style.module.scss";
import { SetState } from "shared/types/general";
import { IMaskInput } from "react-imask";

interface InputProps {
  value: string;
  setValue: SetState<string>;
  label: string;
  id: string;
  placeholder?: string;
  mask: any;
  disabled?: boolean;
}

const SecondaryInput: React.FC<InputProps> = ({
  label,
  setValue,
  value,
  id,
  placeholder,
  mask,
  disabled = false,
}) => {
  return (
    <div className={s.input}>
      <label htmlFor={id}>{label}</label>
      <IMaskInput
        type="text"
        placeholder={placeholder}
        mask={mask}
        radix="."
        id={id}
        value={value}
        onAccept={(value) => setValue(value)}
        disabled={disabled}
      />
    </div>
  );
};

export default SecondaryInput;
